import { Link } from "react-router-dom";
import { ArrowUpRight, Shield, Leaf, Clock, Award } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { photoById } from "@/data/portfolio";
import { WorkPhoto } from "@/components/portfolio/WorkPhoto";
import { Reveal } from "@/components/portfolio/Reveal";

export default function About() {
  const { t } = useLanguage();
  const features = [{ icon: Shield, key: "expertise", link: "/team" }, { icon: Leaf, key: "eco", link: "/eco-products" }, { icon: Clock, key: "flexible" }, { icon: Award, key: "quality" }];
  return <section id="about" data-testid="about-section" className="studio-section bg-white">
    <div className="studio-container grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
      <Reveal className="lg:col-span-5">
        <p className="studio-eyebrow">{t("about.subtitle")}</p><h2 className="studio-heading">{t("about.title")}</h2>
        <p className="text-slate-600 text-sm sm:text-base leading-relaxed mt-6">{t("about.description1")}</p>
        <p className="text-slate-500 text-sm leading-relaxed mt-4 mb-8">{t("about.description2")}</p>
        <Link to="/team" data-testid="about-team-link" className="studio-text-link">{t("about.features.expertise.title")}<ArrowUpRight size={18} /></Link>
        <div className="grid sm:grid-cols-2 gap-x-6 gap-y-7 mt-10">
          {features.map(({ icon: Icon, key, link }) => <div key={key} className="border-t border-slate-200 pt-5">
            <Icon aria-hidden="true" className="h-5 w-5 text-marine-600 mb-3" />
            <h3 className="font-semibold text-sm text-navy-900">{t(`about.features.${key}.title`)}</h3>
            <p className="text-sm text-slate-500 leading-relaxed mt-2">{t(`about.features.${key}.desc`)}</p>
            {link && <Link to={link} data-testid={`about-feature-${key}`} className="inline-flex gap-2 items-center text-xs text-marine-700 mt-3 hover:underline">{t("gallery.view")}<ArrowUpRight size={14} /></Link>}
          </div>)}
        </div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <WorkPhoto photo={photoById("apartment-19")} testId="about-team-photo" className="w-full h-auto" sizes="(max-width: 1024px) 100vw, 55vw" />
        <p className="text-xs text-slate-500 pt-4 border-t border-slate-200 mt-4">Shylov Cleaning · {t("studio.workIntro")}</p>
      </Reveal>
    </div>
  </section>;
}